import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./anim";

const FAQS = [
  { q: "How do I join Noizbloc?", a: "Noizbloc is open sign-up. Create an account with your email and password (or Google) as an artist or label — you can upload your first release the same day." },
  { q: "Which stores do you deliver to?", a: "We deliver to 150+ platforms including Spotify, Apple Music, Tidal, Amazon Music, Deezer, YouTube Music, TikTok and Instagram." },
  { q: "How much of my royalties do I keep?", a: "You keep 100% of your streaming royalties. Noizbloc never takes a commission on your earnings." },
  { q: "How long until my release goes live?", a: "Most releases are reviewed and delivered within 48 hours. Pro members get priority 24-hour review." },
  { q: "Can labels manage multiple artists?", a: "Yes. The Label plan gives you a team workspace with unlimited artists, royalty splits and a dedicated manager." },
  { q: "Do I keep the rights to my music?", a: "Always. You retain 100% ownership of your masters and compositions. Noizbloc is a distributor, not a rights owner." },
];

export default function Faq() {
  return (
    <section id="faq" className="py-24 sm:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <Reveal>
          <div className="mb-12">
            <span className="text-xs tracking-[0.25em] uppercase font-bold text-slate-400">FAQ</span>
            <h2 className="mt-4 font-display font-medium tracking-tight text-white text-3xl sm:text-4xl md:text-5xl">
              Questions, answered.
            </h2>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display text-lg md:text-xl text-white hover:no-underline py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
